import { render, staticRenderFns } from "./AdsPopup.vue?vue&type=template&id=8191e73e&scoped=true"
import script from "./AdsPopup.vue?vue&type=script&lang=js"
export * from "./AdsPopup.vue?vue&type=script&lang=js"
import style0 from "./AdsPopup.vue?vue&type=style&index=0&id=8191e73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8191e73e",
  null
  
)

export default component.exports